import {
    USER_MNGT_ONLOAD_SUCCESS,
    USER_MNGT_ONLOAD_FAILED,
    USER_SEARCH,
    USER_SEARCH_SUCCESSFUL,
    USER_SEARCH_RESET,
    CE_USER_ONLOAD_SUCCESS,
    USER_SEARCH_FAILED,
    CE_USER,
    CE_USER_SUCCESS,
    CE_USER_FAILED,
    CE_USER_ON_RESET,
} from './actions';
import {CREATE_MODE} from 'utils/appConstant'

const initialState = {
    init: true,
    crud_init: false,
    selectData: null,
    params: null,
    userList: null,
    systemRoles: null,
    lastErrorMessage: null,
    ceUserLoading: false,
    actionMode: null,
    messageType: null,
    lastMessage: null,
}
  
const getUserList = userPagingnation => {
    return userPagingnation.content
}

const getErrorMessage = error => {
    return error.message
}

const createSystemRoleOptions = roles => {
    const option = roles ? [...roles].sort((first, second) => first.id - second.id)
        .map((obj) => ({value: obj.id, label:`${obj.name}${obj.functionName ? '(' + obj.functionName + ')' : ''}`})) : [];
    // console.log('option', option);
    return option;
}


  export function userManagementReducer(state = initialState, action) {
    let data = action.payload;
  
    switch (action.type) {
        case USER_MNGT_ONLOAD_SUCCESS:
            return {
                ...state,
                init: true,
                params: data
              }
        case USER_MNGT_ONLOAD_FAILED:
            return {
                ...state,
                init: true,
                lastErrorMessage: getErrorMessage(data)
            }
        case USER_SEARCH:
            return {
                ...state,
                params: data,
                userList: null
            }
        case USER_SEARCH_SUCCESSFUL:
            return {
                ...state,
                userList: getUserList(data),
                lastErrorMessage: null
            }
        case USER_SEARCH_FAILED:
            return {
                ...state,
                userList: [],
                lastErrorMessage: getErrorMessage(data),
            }
        case USER_SEARCH_RESET:
            return {
                ...state,
                userList: [],
                lastErrorMessage: null
            }
        case CE_USER_ONLOAD_SUCCESS:
            return {
                ...state,
                crud_init: true,
                systemRoles: createSystemRoleOptions(data.roles)
            }
        case CE_USER:
            return {
                ...state,
                ceUserLoading: true,
                actionMode: data.mode
            }
        case CE_USER_SUCCESS:
            return {
                ...state,
                ceUserLoading: false,
                messageType: "success",
                // default is UPDATE_MODE
                lastMessage: state.actionMode===CREATE_MODE ? "Create a new User successfully" : "Update User Info successfully",
                userList: [],
            }
        case CE_USER_FAILED:
            return {
                ...state,
                ceUserLoading: false,
                messageType: "error",
                lastMessage: data.message,
                userList: [],
            }
        case CE_USER_ON_RESET:
            return {
                ...state,
                ceUserLoading: false,
                messageType: null,
                lastMessage: null,
            }
        default:
            //console.log('userManagementReducer Unimplemented', action.type)
            return state;
    }
}